import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { Product } from 'src/app/products/product.model';
import { ProductsService } from 'src/app/shared/services/products.service';

@Injectable({
  providedIn: 'root'
})
export class AppFacadeService {
  private readonly isLoadingData$ = new BehaviorSubject<boolean>(false);
  private readonly products$ :Observable<Product[]>;


  constructor(private productService: ProductsService) {
    this.isLoadingData$.next(true);
    this.products$ = this.productService.getProducts().pipe(shareReplay(1));
    this.products$.subscribe(()=> this.isLoadingData$.next(false));
   
  }

  public get isLoading$(): Observable<boolean> {
    return this.isLoadingData$.asObservable();
  }

  public get topLevelProducts$(): Observable<Product[]> {
    return this.products$.pipe(
      map(products => products.filter(p => (!p.children || p.children.length === 0) && p.link && p.link.trim() !== ''))
    );
  }

  public get productsWithChildren$(): Observable<Product[]> {
    return this.products$.pipe(
      map(products => products.filter(p => p.children && p.children.length > 0))
    );
  }

  public get productsLoaded$(): Observable<boolean> {
    return this.products$.pipe(switchMap(products => { return of(products.length > 0) }));
  }
}
